import config from '@/config';
import { LogicContext } from '@/logic/main/types';

export const prepareJackpotBetWidgetContent = async (context: LogicContext) => {
  const jackpotBetWidgetComponentID =
    context.jackpotBetWidgetComponent?.id || '';
  const currencyCode = context.user?.currency || config.default_currency;

  if (!jackpotBetWidgetComponentID) {
    return { updates: [] };
  }

  const updates = [
    {
      type: 'setLayoutProperty',
      data: {
        path: `components.${jackpotBetWidgetComponentID}.properties`,
        value: {
          jpAmounts: context.jackpotBetFeeds?.jpAmounts,
          winnersToday: context.jackpotBetFeeds?.winnersToday,
          winsToday: context.jackpotBetFeeds?.winsToday,
          currencyCode,
        },
      },
    },
  ];
  return { updates };
};
